<channel-control>
  <div class="col-12">
    <div class="device-control-channel h-100">
      <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-2 device-control-channel-header">
        <div class="d-flex align-items-center gap-2">
          <span class="channel-led channel-led-{ getChannelStateClass() }" title="Estado: { getChannelStateValue() }"></span>
          <div>
            <strong>{ props.channel.name }</strong>
            <span class="badge bg-secondary rounded-pill ms-1 fw-normal small">{ props.channel.channel }</span>
            <span class="ms-2 badge rounded-pill bg-{ getChannelStateClass() }-subtle text-{ getChannelStateClass() } border border-{ getChannelStateClass() }-subtle">
              { getChannelStateValue() }
            </span>
          </div>
        </div>

        <div if={ isOutputChannel() } class="d-flex gap-2 align-items-center flex-wrap device-control-actions">
          <button
            class="btn btn-{ isScheduleActive() ? 'primary' : 'outline-warning' } btn-sm"
            onclick={ handleOpenDoor }
            disabled={ !props.isOnline }
            title={ !isScheduleActive() ? 'Abrir puerta (forzado - fuera del horario permitido)' : 'Abrir Puerta' }
          >
            <i class="bi bi-unlock-fill me-1"></i> Abrir puerta
          </button>
          <button
            class="btn btn-outline-secondary btn-sm"
            onclick={ handleEditSchedule }
            title="Configurar horarios de apertura automática"
          >
            <i class="bi bi-calendar-week me-1"></i> Horarios
          </button>
          <button
            class="btn btn-sm btn-outline-secondary"
            onclick={ handleShowScheduleHelp }
            title="Ayuda sobre calendarización"
          >
            <i class="bi bi-question-circle"></i>
          </button>
        </div>
      </div>

      <div if={ isOutputChannel() && hasSchedule() } class="schedule-info schedule-info--{ getScheduleState() }">
        <i class="schedule-info-icon bi bi-{ getScheduleIcon() }"></i>
        <span class="schedule-info-label">{ getScheduleLabel() }</span>
        <span if={ isScheduleEnabled() && props.channel.schedule.days } class="schedule-info-days">
          { formatDays(props.channel.schedule.days) }
        </span>
      </div>
    </div>
  </div>

  <script>
    import { isChannelActive } from '../utils/schedule-utils'

    export default {
      isScheduleActive() {
        return isChannelActive(this.props.channel)
      },
      isOutputChannel() {
        return this.props.channel.channel.startsWith('out');
      },

      getChannelStateClass() {
        switch(this.props.channel.lastState) {
          case 'ON': return 'primary';
          case 'OFF': return 'secondary';
          default: return 'secondary';
        }
      },

      getChannelStateValue() {
        return this.props.channel.lastState !== undefined ? this.props.channel.lastState : 'N/D';
      },

      hasSchedule() {
        return this.props.channel.schedule !== undefined;
      },

      isScheduleEnabled() {
        return this.props.channel.schedule && this.props.channel.schedule.enabled === true;
      },

      // Tres estados posibles del horario, en un solo lugar:
      // - 'active'     -> habilitado y dentro de la franja horaria actual
      // - 'outofhours' -> habilitado pero fuera de la franja en este momento
      // - 'inactive'   -> guardado pero deshabilitado
      getScheduleState() {
        if (!this.isScheduleEnabled()) return 'inactive';
        return this.isScheduleActive() ? 'active' : 'outofhours';
      },

      getScheduleLabel() {
        switch (this.getScheduleState()) {
          case 'active': return 'Activo ahora';
          case 'outofhours': return 'Fuera de horario';
          default: return 'Desactivado';
        }
      },

      getScheduleIcon() {
        switch (this.getScheduleState()) {
          case 'active': return 'calendar-check-fill';
          case 'outofhours': return 'calendar-week';
          default: return 'calendar-x';
        }
      },

      formatDays(days) {
        if (!days || !days.length) {
          return 'Ninguno';
        }
        const dayNames = ['D', 'L', 'M', 'X', 'J', 'V', 'S'];
        return days.sort().map(day => dayNames[day]).join(', ');
      },

      handleOpenDoor(e) {
        if (e) e.preventDefault();
        if (this.props.onOpenDoor) {
          this.props.onOpenDoor(this.props.channel.channel);
        }
      },

      handleEditSchedule(e) {
        if (e) e.preventDefault();
        if (this.props.onEditSchedule) {
          this.props.onEditSchedule(this.props.channel);
        }
      },

      handleShowScheduleHelp(e) {
        if (e) e.preventDefault();
        if (this.props.onShowScheduleHelp) {
          this.props.onShowScheduleHelp();
        }
      }
    }
  </script>
</channel-control>
